export default __webpack_public_path__ + "static/media/close.81a9859a.svg";